import {
  createSelector,
} from 'reselect';
import i18n from 'i18next';
import {
  getStatus,
} from 'redux-resource';

import {
  coreSelectors,
} from '@gymcloud/core';

export const getSidebarProFolders = createSelector(
  [
    coreSelectors.getTreeFoldersWithItems('exercises'),
    coreSelectors.getTreeFoldersWithItems('documents'),
    coreSelectors.getTreeFoldersWithItems('workoutTemplates'),
    coreSelectors.getTreeFoldersWithItems('programTemplates'),
    coreSelectors.getResourceMeta('conversations', 'unread'),
    store => getStatus(store, 'folders.requests.fetchLibrary.status'),
  ],
  (
    exercises,
    documents,
    workoutTemplates,
    programTemplates,
    unread,
    fetchLibraryStatus,
  ) => ([
    {
      icon: 'dashboard',
      link: 'welcome',
      name: 'Dashboard',
    },
    {
      icon: 'clients',
      link: 'clients/individuals',
      name: i18n.t('client_plural'),
      additionalPaths: [
        'users',
        'client_groups',
        'personal_programs',
        'personal_workouts',
      ],
      children: [
        {
          icon: 'clients',
          link: 'clients/individuals',
          name: 'Individuals',
        },
        {
          icon: 'groups',
          link: 'clients/groups',
          name: 'Groups',
        },
        {
          icon: 'clients',
          link: 'clients/archived',
          name: 'Archived',
        },
      ],
    },
    {
      icon: 'messages',
      link: 'messages',
      name: 'Messages',
      badge: unread?.count > 0 ? unread.count : null,
    },
    {
      icon: 'calendar',
      link: 'calendar',
      name: 'Calendar',
    },
    {
      icon: 'billing',
      link: 'billing/invoices',
      name: 'Billing',
    },
    ...(fetchLibraryStatus.succeeded ? [
      {
        ...exercises,
        icon: 'exercises',
        link: 'exercises',
        name: 'Exercises',
        isFolder: true,
      },
      {
        ...workoutTemplates,
        icon: 'workout2',
        link: 'workout_templates',
        name: i18n.t('workoutTemplates'),
        isFolder: true,
      },
      {
        ...programTemplates,
        icon: 'programs',
        link: 'program_templates',
        name: 'Program Templates',
        isFolder: true,
      },
    ] : []),
    {
      icon: 'videogallery',
      link: 'videos/recent',
      name: 'Video Library',
    },
    ...(fetchLibraryStatus.succeeded ? [
      {
        ...documents,
        icon: 'documents',
        link: 'documents',
        name: 'Documents',
        isFolder: true,
      },
    ] : []),
    {
      icon: 'trainings',
      link: 'users/me',
      name: 'My Training Log',
    },
    {
      icon: 'properties',
      link: 'personal_properties',
      name: 'Metrics',
    },
  ]),
);

export const getSidebarClientFolders = createSelector(
  [
    coreSelectors.getFolderItemsSortedByName('personalExercises'),
    coreSelectors.getFolderItemsSortedByName('personalWarmups'),
    coreSelectors.getFolderItemsSortedByName('personalWorkouts'),
    coreSelectors.getFolderItemsSortedByName('personalCooldowns'),
    coreSelectors.getFolderItemsSortedByName('personalPrograms'),
  ],
  (
    personalExercises,
    personalWarmups,
    personalWorkouts,
    personalCooldowns,
    personalPrograms,
  ) => ([
    {
      icon: 'dashboard',
      link: 'welcome',
      name: 'Dashboard',
    },
    {
      icon: 'exercises',
      link: 'personal_exercises',
      name: 'Exercises',
      children: personalExercises,
    },
    {
      icon: 'warmups',
      link: 'personal_warmups',
      name: 'Warmups',
      children: personalWarmups,
    },
    {
      icon: 'workout2',
      link: 'personal_workouts',
      name: i18n.t('Workouts'),
      children: personalWorkouts,
    },
    {
      icon: 'cooldowns',
      link: 'personal_cooldowns',
      name: 'Cooldowns',
      children: personalCooldowns,
    },
    {
      icon: 'programs',
      link: 'personal_programs',
      name: 'Programs',
      children: personalPrograms,
    },
    {
      icon: 'videogallery',
      link: 'videos/recent',
      name: 'Video Library',
    },
    {
      icon: 'documents',
      link: 'documents',
      name: 'Documents',
    },
  ]),
);
